import React, { useEffect, useRef, useState } from "react";
import "remixicon/fonts/remixicon.css";
import arrow from "../Assets/imgs/arrow.webp";
import gsap from "gsap";
import { animateTextChange } from "../utils/GSAPFunctions";

const CaseStudy = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const headingRefs = useRef<HTMLElement[]>([]);
  const prevIndexRef = useRef(0); // used to track previous index
  const profitRef = useRef<HTMLDivElement | null>(null);

  const slideContent = [
    {
      title: [
        "Strategic Integrated Marketing Approach",
        "Drives Nearly 7X Increase In Gross Profit",
        "for Cybersecurity Company",
      ],
      profit: "20",
      profitText: "million increase in gross profit",
      wonRate: "05",
      wonRateText: "% increase in closed-won profit",
      years: "03",
      yearsText: "consecutive years secured in Inc. 500",
    },
    {
      title: [
        "2 Strategic Integrated Marketing Approach",
        "2 Drives Nearly 7X Increase In Gross Profit",
        "2 for Cybersecurity Company",
      ],
      profit: "50",
      profitText: "million increase in gross profit",
      wonRate: "10",
      wonRateText: "% increase in closed-won profit",
      years: "40",
      yearsText: "consecutive years secured in Inc. 500",
    },
    {
      title: [
        "3 Strategic Integrated Marketing Approach",
        "3 Drives Nearly 7X Increase In Gross Profit",
        "3 for Cybersecurity Company",
      ],
      profit: "60",
      profitText: "million increase in gross profit",
      wonRate: "100",
      wonRateText: "% increase in closed-won profit",
      years: "80",
      yearsText: "consecutive years secured in Inc. 500",
    },
  ];

  useEffect(() => {
    headingRefs.current.forEach((el, i) => {
      if (el) {
        gsap.set(el, {
          opacity: i === 0 ? 1 : 0,
          y: i === 0 ? 0 : 50,
          position: i === 0 ? "relative" : "absolute",
        });
      }
    });
  }, []);

  const showSlide = (newIndex: number) => {
    if (newIndex === activeIndex || !headingRefs.current[newIndex]) return;

    const prevIndex = activeIndex;
    prevIndexRef.current = prevIndex;

    const currentEl = headingRefs.current[prevIndex];
    const nextEl = headingRefs.current[newIndex];

    animateTextChange({
      currentEl,
      nextEl,
      profitEl: profitRef.current,
      currentData: slideContent[prevIndex],
      nextData: slideContent[newIndex],
    });

    setActiveIndex(newIndex);
  };

  return (
    <div className="__CaseStudySection">
      <div className="container-fluid">
        <div className="__CaseStudyWraper">
          <div className="__CaseStudyTop">
            <div className="__CaseStudyHeading">Latest CASE STUDIES</div>
            <div className="__navigationBtn">
              <button
                className="__prevBtn"
                onClick={() =>
                  showSlide(
                    (activeIndex - 1 + slideContent.length) % slideContent.length
                  )
                }
              >
                <div className="__prevIstChild">
                  <i className="ri-arrow-left-line"></i>
                </div>
                <div className="__prevScndChild">
                  <i className="ri-arrow-left-line"></i>
                </div>
              </button>

              <button
                className="__NextBtn"
                onClick={() => showSlide((activeIndex + 1) % slideContent.length)}
              >
                <div className="nextIstChild">
                  <i className="ri-arrow-right-line"></i>
                </div>
                <div className="nextscndChild">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
            </div>
          </div>

          {/* Slide Headings */}
          {slideContent.map((slide, i) => (
            <div
              key={i}
              ref={(el) => el && (headingRefs.current[i] = el)}
              style={{
                position: i === activeIndex ? "relative" : "absolute",
                opacity: i === activeIndex ? 1 : 0,
              }}
            >
              <div className="__caseStudyMainHeading">
                <div className="cs_content_parent">
                  {slide.title.map((line, idx) => (
                    <div className="overflow-hidden" key={idx}>
                      <span className="block">{line}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}

          {/* Profit Cards */}
          <div className="__profitWraper" ref={profitRef}>
            <div className="__profitCard">
              <div className="__percProfit">
                {slideContent[activeIndex].profit}
              </div>
              <div className="__shortDesc">
                {slideContent[activeIndex].profitText}
              </div>
            </div>
            <div className="__profitCard">
              <div className="__percProfit">
                {slideContent[activeIndex].wonRate}
              </div>
              <div className="__shortDesc">
                {slideContent[activeIndex].wonRateText}
              </div>
            </div>
            <div className="__profitCard">
              <div className="__percProfit">
                {slideContent[activeIndex].years}
              </div>
              <div className="__shortDesc">
                {slideContent[activeIndex].yearsText}
              </div>
            </div>
          </div>

          {/* Button */}
          <div className="__defaultBtn">
            <span className="__leftSvg">
              <img src={arrow} alt="arrow" />
            </span>
            <div className="__rightSideArrow">
              <p> VIEW CASE STUDY</p>
              <span className="__rightSvg">
                <img src={arrow} alt="arrow" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudy;
